import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import {
  Checkbox, Chip, DialogContent, Grid, List, ListItemButton, ListItemIcon, ListSubheader,
  // MenuItem
} from '@mui/material';
// import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';
import PropTypes from 'prop-types';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { dataConstants } from '../../constants';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { SortableContainer, SortableElement } from '../_common/SortableHOC';
import DragHandleRoundedIcon from '@mui/icons-material/DragHandleRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import SortRoundedIcon from '@mui/icons-material/SortRounded';
import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';
// import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import { getRandomStr } from '../../helpers';

// Custom sorting function
const customSort = (a, b) => {
  if (a.name === "" && b.name !== "") {
    return 1; // Move objects with empty "name" to the end
  } else if (a.name !== "" && b.name === "") {
    return -1; // Keep objects with non-empty "name" at the beginning
  } else {
    return 0; // Maintain the original order for other objects
  }
};

const SortableItem = SortableElement(({ value, handleDelete }) => (
  // <Box component="li" sx={{ zIndex: 1301, display: 'flex', alignItems: 'center', mr: 2 }}>
  <ListItem sx={{ background: '#fbfbfcba', zIndex: 1301, p: 0, borderRadius: '5px', boxShadoww: '0px 4px 4px -2px rgba(0,0,0,0.2)' }}>
    <Chip label={value?.name}
      // onDelete={handleDelete}
      avatar={<DragHandleRoundedIcon />}
      // deleteIcon={<CloseRoundedIcon sx={{ zIndex: 9999, fontSize: '20px !important' }} />}
      sx={{
        width: '150pxx', textAlign: 'left', pr: 1,
        borderRadius: '0px', height: '37px',
        '& .MuiChip-label': { px: '20px', mr: 'auto' },
        cursor: 'grab', background: 'transparent', border: '1px solid #c0c0c052', border: 0
      }}
    />
  </ListItem>
  //   <IconButton size="small" onClick={() => handleDelete(value)}>
  //     <CloseRoundedIcon fontSize="small" sx={{ zIndex: 9999, fontSize: '20px !important' }} />
  //   </IconButton>
  // </Box>
));

const SortableList = SortableContainer(({ items, handleDelete }) => {
  const filteredArray = items?.filter(item => item?.name !== "");
  return (
    <List sx={{ width: '100%', py: 0 }}>
      <ListSubheader sx={{ zIndex: 1301 + 1, background: '#fbfbfc', px: 1, py: .5, color: 'primary.main' }}>
        {/* <SortRoundedIcon sx={{ fontSize: '1.2rem', verticalAlign: 'sub' }} /> */}
        Columns Order:
      </ListSubheader>
      {filteredArray?.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value} handleDelete={handleDelete} />
      ))}
    </List>
  );
});

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const { DEFAULT_TBL_COLS } = dataConstants;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ManageColumnsDialog({ arrayOrder, columns, setColumnGroups, setColumns, onSortEnd, handleSaveColumns }) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCheckboxChange = (item) => {
    // Check if the item is already in the selectedItems array
    const index = selectedItems?.findIndex((selectedItem) => selectedItem?.name === item?.name);

    if (index === -1) {
      // If not, add it to the selectedItems array
      setSelectedItems([...selectedItems, item]);
      handleColumns([...selectedItems, item])
    } else {
      // If it's already selected, remove it from the array
      const updatedItems = [...selectedItems];
      updatedItems.splice(index, 1);
      setSelectedItems(updatedItems);
      handleColumns(updatedItems)
    }
  };

  // Group the data by label
  const groupedData = DEFAULT_TBL_COLS?.slice(2)?.reduce((acc, item) => {
    if (!acc[item.label]) {
      acc[item.label] = [];
    }
    acc[item.label].push(item);
    return acc;
  }, {});

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    handleSaveColumns(columns)
  };


  // const sortSelectedItems = (selectedItems, arrayOrder) =>
  //   arrayOrder?.reduce((acc, { name }) => [...acc, ...selectedItems?.filter((item) => item?.label === name)], [])
  //     ?.concat(selectedItems?.filter((item) => !arrayOrder?.some((orderItem) => orderItem?.name === item?.label)));

  // const sortedSelectedItems = sortSelectedItems(selectedItems, arrayOrder);

  const updateColSpanAndIncludeCols = (arrayOrder, selectedItems) =>
    arrayOrder.map((orderItem) => ({
      ...orderItem,
      colSpan: orderItem?.name === '' ? orderItem?.colSpan : selectedItems?.filter((item) => item?.label === orderItem?.name)?.length?.toString(),
      includeCols: orderItem?.name === '' ? orderItem?.includeCols : selectedItems?.filter((item) => item?.label === orderItem?.name).map((item) => item?.field),
    }));

  const updatedArrayOrder = updateColSpanAndIncludeCols(arrayOrder, selectedItems);

  const handleColumns = (_selectedItems) => {
    // const reqObjs = [
    //   { "name": "Ticker", "tooltip": "Ticker", "field": "ticker", "urlField": "ticker", "class": "text-left", sortFunc: (a, b) => a.localeCompare(b) },
    //   { "name": "Name", "tooltip": "Name", "field": "tickername", "class": "td-color", "urlField": "ticker" },
    // ]
    // const uniqueSortedSelectedItems = sortSelectedItems(_selectedItems, arrayOrder)?.filter(
    //   (item) => !reqObjs.some((newItem) => newItem?.name === item?.name)
    // );

    // setColumns([...reqObjs, ...uniqueSortedSelectedItems])
    setColumns(_selectedItems.sort(customSort))
    // setColumns(_selectedItems)
    setColumnGroups(updatedArrayOrder)
    // setOpen(false);
  };

  const countSelectedItems = (label) => {
    const items = groupedData[label];
    const selectedCount = items?.filter(item => selectedItems?.some(selected => (
      item.name === selected?.name && item?.field === selected?.field
    )))?.length;
    return selectedCount;
  }

  React.useEffect(() => {
    setSelectedItems(columns)
  }, [columns])

  return (
    <>
      <LightTooltip describeChild title="Manage Columns" placement="top" disableInteractive>
        <IconButton onClick={handleClickOpen} sx={{ mr: 1 }}>
          <ViewColumnRoundedIcon fontSize="small" sx={{ color: '#434166' }} />
        </IconButton>
      </LightTooltip>
      {/* <MenuItem onClick={handleClickOpen}
      // disabled={isSystemDefault}
      >
        <ListItemIcon>
          <ViewColumnRoundedIcon fontSize="small" />
        </ListItemIcon>
        <Typography variant="inherit" noWrap fontSize="small" >
          Manage Columns
        </Typography>
      </MenuItem> */}
      <Dialog
        fullScreen={!matches}
        // fullWidth={true}
        maxWidth={'md'}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative', zIndex: 1304 }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Manage Columns
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose} sx={{ textTransform: "none", background: '#ffffff21', '&:hover': { background: '#ffffff29' } }}>
              Save Changes
            </Button>
          </Toolbar>
        </AppBar>
        {/* <List>
          <ListItem button>
            <ListItemText primary="Phone ringtone" secondary="Titania" />
          </ListItem>
          <Divider />
          <ListItem button>
            <ListItemText
              primary="Default notification ringtone"
              secondary="Tethys"
            />
          </ListItem>
        </List> */}
        <DialogContent className="manage-column-dialog" sx={{ p: 0, }}>
          <Grid container spacing={2}>
            <Grid item md={3} sm={3.5} xs={12}>
              <Tabs
                orientation={!matches ? "horizontal" : "vertical"}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                selectionFollowsFocus
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs"
                sx={{
                  [`& .${tabsClasses.scrollButtons}`]: {
                    height: '32px',
                    '&.Mui-disabled': {
                      opacity: 0.3
                    },
                  },
                  borderRight: 1, borderColor: 'rgb(0 0 0 / 6%)', maxHeight: { md: 423, sm: 423 }, background: '#f5f6f7', height: matches ? '100%' : '',
                  '& .MuiButtonBase-root.Mui-selected': { background: '#020e4a17', fontWeight: '600', color: 'primary.main' },
                  '& .MuiButtonBase-root': { color: 'rgb(60,64,67)' },
                }}
              >
                {Object.keys(groupedData)?.sort()?.map((label, index) => (
                  <Tab
                    label={label === 'undefined' ? 'Others' : label}
                    key={index}
                    iconPosition="end"
                    icon={<Chip label={countSelectedItems(label)} sx={{ height: '20px', '& .MuiChip-label': { px: .8, color: 'rgba(0, 0, 0, 0.6)', fontWeight: 600 } }} />}
                    sx={{ textTransform: 'none', minHeight: '40px', '&.MuiTab-root': { justifyContent: 'start', fontSize: '.9rem' } }} />
                ))}
              </Tabs>
            </Grid>
            <Grid item md={6} sm={5} xs={12} sx={{ '& .MuiBox-root': { padding: '4px' } }}>
              {Object.keys(groupedData)?.sort()?.map((label, index) => (
                <TabPanel key={getRandomStr(5)} value={value} index={index} sx={{ width: '100%', }}>
                  <ListSubheader sx={{ px: 1, background: "#fff", color: 'primary.main', fontSize: '.9rem' }}>{label === 'undefined' ? 'Others' : label}:</ListSubheader>
                  {value === index && (
                    <Grid container sx={{
                      p: '0 !important', maxHeight: { md: 350, sm: 350 }, overflow: 'scroll',
                      '&::-webkit-scrollbar-thumb': {
                        background: '#020e4a85',
                        borderRadius: '1px'
                      },
                      '&::-webkit-scrollbar-track': {
                        borderRadius: '1px'
                      },
                      '&::-webkit-scrollbar': {
                        width: '5px !important'
                      }
                    }}>
                      {groupedData[label]?.sort((a, b) => a?.name?.localeCompare(b.name, undefined, { sensitivity: 'base' }))?.map((item, itemIndex) => (
                        <Grid item xs={6} sm={6} md={6} key={itemIndex} sx={{ p: '0 !important', maxHeight: { md: 423, sm: 423 }, overflow: 'scroll', }}>
                          <ListItem key={itemIndex} disablePadding>
                            <LightTooltip describeChild title={item?.tooltip} placement="top" disableInteractive>
                              <ListItemButton role={undefined} onClick={() => handleCheckboxChange(item)} dense sx={{ px: '12px', py: '3px', '& .MuiListItemText-secondary': { display: 'none' }, '&:hover .MuiListItemText-secondary': { display: 'block' } }}>
                                <ListItemIcon sx={{ minWidth: '32px' }}>
                                  <Checkbox
                                    edge="start"
                                    sx={{ padding: '0 5px' }}
                                    checked={selectedItems?.some((selectedItem) => selectedItem?.name === item?.name)}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': item?.field }}
                                  />
                                </ListItemIcon>
                                <ListItemText id={item?.field} primary={item?.name} />
                              </ListItemButton>
                            </LightTooltip>
                          </ListItem>
                          {/* <Checkbox
                              checked={selectedItems.some((selectedItem) => selectedItem.name === item.name)}
                              onChange={() => handleCheckboxChange(item)}
                            />
                            {item.name} */}
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </TabPanel>
              ))}
            </Grid>
            <Grid item md={3} sm={3.5} xs={12}
              // sx={{ display: { xs: 'none', md: 'block', sm: 'block' } }}
              sx={{
                width: '100%', background: '#fbfbfc',
                // filter: open ? 'blur(3px)' : 'unset',
                borderLeft: 1, borderColor: 'rgb(0 0 0 / 5%)', height: '100%',
                maxHeight: { md: 423, sm: 423 }, overflow: 'auto',
                '&::-webkit-scrollbar-thumb': {
                  background: '#020e4a85',
                  borderRadius: '1px'
                },
                '&::-webkit-scrollbar-track': {
                  borderRadius: '1px'
                },
                '&::-webkit-scrollbar': {
                  width: '5px !important'
                }
              }}>
              <SortableList
                items={columns}
                onSortEnd={onSortEnd}
                handleDelete={handleCheckboxChange}
              // hideSortableGhost={false}
              />
            </Grid>
          </Grid>
          {/* <TabPanel value={value} index={0}>
            Item One
          </TabPanel>
          <TabPanel value={value} index={1}>
            Item Two
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel>
          <TabPanel value={value} index={3}>
            Item Four
          </TabPanel>
          <TabPanel value={value} index={4}>
            Item Five
          </TabPanel>
          <TabPanel value={value} index={5}>
            Item Six
          </TabPanel>
          <TabPanel value={value} index={6}>
            Item Seven
          </TabPanel> */}
        </DialogContent>
      </Dialog>
    </>
  );
}


// import * as React from 'react';
// import Button from '@mui/material/Button';
// import Dialog from '@mui/material/Dialog';
// import { styled } from '@mui/material/styles';
// import ListItemText from '@mui/material/ListItemText';
// import ListItem from '@mui/material/ListItem';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import AppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
// import CloseIcon from '@mui/icons-material/Close';
// import Slide from '@mui/material/Slide';
// import { Checkbox, Chip, DialogContent, Grid, List, ListItemButton, ListItemIcon, ListSubheader, MenuItem } from '@mui/material';
// import ViewColumnRoundedIcon from '@mui/icons-material/ViewColumnRounded';
// import PropTypes from 'prop-types';
// import Tabs, { tabsClasses } from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Box from '@mui/material/Box';
// import { dataConstants } from '../../constants';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
// import { SortableContainer, SortableElement } from '../_common/SortableHOC';
// import DragHandleRoundedIcon from '@mui/icons-material/DragHandleRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import SortRoundedIcon from '@mui/icons-material/SortRounded';
// import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';

// const SortableItem = SortableElement(({ value, handleDelete }) => (
//   <ListItem sx={{ zIndex: 9999, }}>
//     <Chip label={value?.name}
//       // onDelete={handleDelete}
//       avatar={<DragHandleRoundedIcon />} deleteIcon={<CloseRoundedIcon sx={{ zIndex: 999999 }} />}
//       sx={{ width: '88vw', textAlign: 'left', borderRadius: '4px', '& .MuiChip-label': { px: '20px', mr: 'auto' }, cursor: 'grab', background: '#f5f6f7', border: '1px solid #c0c0c052' }}
//     />
//   </ListItem>));

// const SortableList = SortableContainer(({ items, handleDelete }) => {
//   const filteredArray = items?.filter(item => item.name !== "");
//   return (
//     <List sx={{ width: '100%' }}>
//       {filteredArray.map((value, index) => (
//         <SortableItem key={`item-${index}`} index={index} value={value} handleDelete={handleDelete} />
//       ))}
//     </List>
//   );
// });

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.arrow}`]: {
//     // color: theme.palette.primary.main,
//     color: "#2a2d64",
//   },
//   [`& .${tooltipClasses.tooltip}`]: {
//     // backgroundColor: theme.palette.primary.main,
//     backgroundColor: "#2a2d64",
//     fontWeight: 600,
//     color: '#fff',
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//     padding: '5px 15px',
//   },
// }));

// const { DEFAULT_TBL_COLS } = dataConstants;

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`vertical-tabpanel-${index}`}
//       aria-labelledby={`vertical-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box sx={{ p: 3 }}>
//           <Typography>{children}</Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// function a11yProps(index) {
//   return {
//     id: `vertical-tab-${index}`,
//     'aria-controls': `vertical-tabpanel-${index}`,
//   };
// }

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

// export default function ManageColumnsDialog({ arrayOrder, columns, setColumnGroups, setColumns, onSortEnd }) {
//   const [open, setOpen] = React.useState(false);
//   const [value, setValue] = React.useState(0);
//   const [selectedItems, setSelectedItems] = React.useState([]);
//   const theme = useTheme();
//   const matches = useMediaQuery(theme.breakpoints.up('sm'));

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const handleCheckboxChange = (item) => {
//     // Check if the item is already in the selectedItems array
//     const index = selectedItems.findIndex((selectedItem) => selectedItem.name === item.name);

//     if (index === -1) {
//       // If not, add it to the selectedItems array
//       setSelectedItems([...selectedItems, item]);
//     } else {
//       // If it's already selected, remove it from the array
//       const updatedItems = [...selectedItems];
//       updatedItems.splice(index, 1);
//       setSelectedItems(updatedItems);
//     }
//   };

//   // Group the data by label
//   const groupedData = DEFAULT_TBL_COLS?.slice(2)?.reduce((acc, item) => {
//     if (!acc[item.label]) {
//       acc[item.label] = [];
//     }
//     acc[item.label].push(item);
//     return acc;
//   }, {});

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };


//   const sortSelectedItems = (selectedItems, arrayOrder) =>
//     arrayOrder.reduce((acc, { name }) => [...acc, ...selectedItems.filter((item) => item.label === name)], [])
//       .concat(selectedItems.filter((item) => !arrayOrder.some((orderItem) => orderItem.name === item.label)));

//   const sortedSelectedItems = sortSelectedItems(selectedItems, arrayOrder);

//   const updateColSpanAndIncludeCols = (arrayOrder, selectedItems) =>
//     arrayOrder.map((orderItem) => ({
//       ...orderItem,
//       colSpan: orderItem.name === '' ? orderItem.colSpan : selectedItems.filter((item) => item.label === orderItem.name).length.toString(),
//       includeCols: orderItem.name === '' ? orderItem.includeCols : selectedItems.filter((item) => item.label === orderItem.name).map((item) => item.field),
//     }));

//   const updatedArrayOrder = updateColSpanAndIncludeCols(arrayOrder, selectedItems);

//   const handleColumns = () => {
//     const reqObjs = [
//       { "name": "Ticker", "field": "ticker", "urlField": "ticker", "isPremium": "Premium" },
//       { "name": "Name", "field": "name", "class": "td-color", "urlField": "ticker", "isPremium": "Premium" },
//       // { "label": "Price", "name": "Price", "field": "PRICE", "class": "text-center", "isSectorValue": "true", "tooltip": "Price" }
//     ]
//     const uniqueSortedSelectedItems = sortedSelectedItems.filter(
//       (item) => !reqObjs.some((newItem) => newItem.name === item.name)
//     );

//     setColumns([...reqObjs, ...uniqueSortedSelectedItems])
//     setColumnGroups(updatedArrayOrder)
//     setOpen(false);
//   };

//   const countSelectedItems = (label) => {
//     const items = groupedData[label];
//     const selectedCount = items.filter(item => selectedItems.some(selected => (
//       item.name === selected.name && item.field === selected.field
//     ))).length;
//     return selectedCount;
//   }

//   React.useEffect(() => {
//     setSelectedItems(columns)
//   }, [columns])

//   return (
//     <>
//       <LightTooltip describeChild title="Manage Columns" placement="top" disableInteractive>
//         <IconButton onClick={handleClickOpen} >
//           <FilterListRoundedIcon fontSize="inherit" sx={{ color: '#434166' }} />
//         </IconButton>
//       </LightTooltip>
//       {/* <MenuItem onClick={handleClickOpen}
//       // disabled={isSystemDefault}
//       >
//         <ListItemIcon>
//           <ViewColumnRoundedIcon fontSize="small" />
//         </ListItemIcon>
//         <Typography variant="inherit" noWrap fontSize="small" >
//           Manage Columns
//         </Typography>
//       </MenuItem> */}
//       <Dialog
//         fullScreen={!matches}
//         scroll={'paper'}
//         fullWidth={true}
//         maxWidth={'lg'}
//         open={open}
//         onClose={handleClose}
//         TransitionComponent={Transition}
//       >
//         <AppBar sx={{ position: 'relative' }}>
//           <Toolbar>
//             <IconButton
//               edge="start"
//               color="inherit"
//               onClick={handleClose}
//               aria-label="close"
//             >
//               <CloseIcon />
//             </IconButton>
//             <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
//               Manage Columns
//             </Typography>
//             <Button autoFocus color="inherit" onClick={handleColumns}>
//               save
//             </Button>
//           </Toolbar>
//         </AppBar>
//         {/* <List>
//           <ListItem button>
//             <ListItemText primary="Phone ringtone" secondary="Titania" />
//           </ListItem>
//           <Divider />
//           <ListItem button>
//             <ListItemText
//               primary="Default notification ringtone"
//               secondary="Tethys"
//             />
//           </ListItem>
//         </List> */}
//         <DialogContent dividers={scroll === 'paper'} sx={{ p: 0, }}>
//           <Grid container spacing={2}>
//             <Grid item md={2.5} sm={3.5} xs={12}>
//               {/* <Tabs
//             orientation="vertical"
//             variant="scrollable"
//             value={value}
//             onChange={handleChange}
//             aria-label="Vertical tabs example"
//             sx={{ borderRight: 1, borderColor: 'divider' }}
//           >
//             <Tab label="Item One" {...a11yProps(0)} />
//             <Tab label="Item Two" {...a11yProps(1)} />
//             <Tab label="Item Three" {...a11yProps(2)} />
//             <Tab label="Item Four" {...a11yProps(3)} />
//             <Tab label="Item Five" {...a11yProps(4)} />
//             <Tab label="Item Six" {...a11yProps(5)} />
//             <Tab label="Item Seven" {...a11yProps(6)} />
//           </Tabs> */}
//               <Tabs
//                 orientation={!matches ? "horizontal" : "vertical"}
//                 variant="scrollable"
//                 scrollButtons={true}
//                 value={value}
//                 onChange={handleChange}
//                 aria-label="Vertical tabs example"
//                 sx={{
//                   [`& .${tabsClasses.scrollButtons}`]: {
//                     '&.Mui-disabled': { opacity: 0.3 },
//                   },
//                   borderRight: 1, borderColor: 'divider', maxHeight: { md: 470, sm: 477 }, background: '#fbfbfc'
//                 }}
//               >
//                 {Object.keys(groupedData).map((label, index) => (
//                   <Tab
//                     label={label}
//                     key={index}
//                     iconPosition="end"
//                     icon={<Chip label={countSelectedItems(label)} sx={{ height: '20px', '& .MuiChip-label': { px: .8, color: 'rgba(0, 0, 0, 0.6)' } }} />}
//                     sx={{ textTransform: 'none', minHeight: '50px' }} />
//                 ))}
//               </Tabs>
//             </Grid>
//             <Grid item md={7} sm={5} xs={12} sx={{ maxHeight: { md: 477, sm: 477 }, overflow: 'auto', }}>
//               {Object.keys(groupedData).map((label, index) => (
//                 <TabPanel value={value} index={index} sx={{ width: '100%', }}>
//                   {value === index && (
//                     <div style={{ marginTop: !matches ? '0px' : '16px' }}>
//                       <Grid container spacing={2}>
//                         {groupedData[label].map((item, itemIndex) => (
//                           <Grid item xs={12} sm={6} md={4} key={itemIndex} sx={{ p: '0 !important', }}>
//                             <ListItem key={itemIndex} disablePadding  >
//                               <ListItemButton role={undefined} onClick={() => handleCheckboxChange(item)} dense>
//                                 <ListItemIcon>
//                                   <Checkbox
//                                     edge="start"
//                                     sx={{ padding: '5px 9px' }}
//                                     checked={selectedItems.some((selectedItem) => selectedItem.name === item.name)}
//                                     tabIndex={-1}
//                                     disableRipple
//                                     inputProps={{ 'aria-labelledby': item.field }}
//                                   />
//                                 </ListItemIcon>
//                                 <ListItemText id={item.field} primary={item.name} />
//                               </ListItemButton>
//                             </ListItem>
//                             {/* <Checkbox
//                               checked={selectedItems.some((selectedItem) => selectedItem.name === item.name)}
//                               onChange={() => handleCheckboxChange(item)}
//                             />
//                             {item.name} */}
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </div>
//                   )}
//                 </TabPanel>
//               ))}
//             </Grid>
//             <Grid item md={2.5} sm={3.5} xs={12} sx={{ display: { xs: 'none', md: 'block', sm: 'block' } }}>
//               <List
//                 sx={{
//                   width: '100%', background: 'transparent',
//                   // filter: open ? 'blur(3px)' : 'unset',
//                   borderLeft: 1, borderColor: 'divider',
//                   maxHeight: { md: 464, sm: 464 }, overflow: 'auto'
//                 }}>
//                 <ListSubheader sx={{ zIndex: 9999 + 1 }}><SortRoundedIcon sx={{ fontSize: '1.2rem', verticalAlign: 'sub' }} /> Sort Columns</ListSubheader>
//                 <SortableList
//                   items={columns}
//                   onSortEnd={onSortEnd}
//                 // handleDelete={handleDelete}
//                 // hideSortableGhost={false}
//                 />
//               </List>
//             </Grid>
//           </Grid>
//           {/* <TabPanel value={value} index={0}>
//             Item One
//           </TabPanel>
//           <TabPanel value={value} index={1}>
//             Item Two
//           </TabPanel>
//           <TabPanel value={value} index={2}>
//             Item Three
//           </TabPanel>
//           <TabPanel value={value} index={3}>
//             Item Four
//           </TabPanel>
//           <TabPanel value={value} index={4}>
//             Item Five
//           </TabPanel>
//           <TabPanel value={value} index={5}>
//             Item Six
//           </TabPanel>
//           <TabPanel value={value} index={6}>
//             Item Seven
//           </TabPanel> */}
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// }
